/** Generated by @gh/common callable client codegen. Do not edit manually. */

import type { CallableApiConfig, RouteTypeMap } from "@gh/common/callable-client";
import type { CanvasTriggerDiscoverPractitionersRequest, CanvasTriggerDiscoverPractitionersResponse, CanvasTriggerPatientResolveRequest, CanvasTriggerPatientResolveResponse, CanvasTriggerPluginLogsSyncRequest, CanvasTriggerPluginLogsSyncResponse, CanvasTriggerPractitionerResolveRequest, CanvasTriggerPractitionerResolveResponse } from "../../src/types";



export interface CanvasMedicalRouteTypeMap extends RouteTypeMap {
  triggerDiscoverPractitioners: {
    request: CanvasTriggerDiscoverPractitionersRequest;
    response: CanvasTriggerDiscoverPractitionersResponse;
  };
  triggerPatientResolve: {
    request: CanvasTriggerPatientResolveRequest;
    response: CanvasTriggerPatientResolveResponse;
  };
  triggerPluginLogsSync: {
    request: CanvasTriggerPluginLogsSyncRequest;
    response: CanvasTriggerPluginLogsSyncResponse;
  };
  triggerPractitionerResolve: {
    request: CanvasTriggerPractitionerResolveRequest;
    response: CanvasTriggerPractitionerResolveResponse;
  };
}

export const canvasMedicalApiConfig = {
  gatewayName: "canvas_medical_default_gateway",
  routes: {
    triggerDiscoverPractitioners: {
      gateway: "canvas_medical_default_gateway",
      action: "triggerDiscoverPractitioners",
    },
    triggerPatientResolve: {
      gateway: "canvas_medical_default_gateway",
      action: "triggerPatientResolve",
    },
    triggerPluginLogsSync: {
      gateway: "canvas_medical_default_gateway",
      action: "triggerPluginLogsSync",
    },
    triggerPractitionerResolve: {
      gateway: "canvas_medical_default_gateway",
      action: "triggerPractitionerResolve",
    },
  },
} as const satisfies CallableApiConfig<CanvasMedicalRouteTypeMap>;
